import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getApiUrl } from '../util/util';
import { get } from './http';

export interface TenantMetricsResponse {
	stats: Stats;
}

export interface Stats {
	count_subclaims_closed: string;
	count_invoices_past_due: string;
	count_invoices_settled: string;
	count_invoices_outstanding: string;
	count_claims_open: string;
	count_policies_pre_issued: string;
	count_policies_on_risk: string;
	count_policies_expired: string;
	count_policyholders: string;
	count_invoices: string;
}

interface MetricsApi {
	fetchTenantMetrics(
		authorizationToken: string,
		config?: AxiosRequestConfig<any>,
	): Promise<AxiosResponse<TenantMetricsResponse>>;
}

export default {
	fetchTenantMetrics(
		authorizationToken: string,
		config?: AxiosRequestConfig<TenantMetricsResponse>,
	) {
		return get(`${getApiUrl()}/_analytics/tenant`, authorizationToken, config);
	},
} as MetricsApi;
